<template>
    <div>
        <vs-card :class="{'log-success': error.success, 'log-error': !error.success}" v-for="(error, index) of logs" :key="index">
            <div>{{error.url}}</div>
        </vs-card>
    </div>
</template>

<script>
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    data() {
        return {
            logList: []
        }
    },

    computed: {
        logs() {
            return this.logList
        }
    },

    methods: {

    },

    async mounted() {
        try {
            const response = await send(this.$url.postback.logs, 'POST', {data: {id: this.popupData}})
            this.logList = response.data.result
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss" scoped>
.log {
    &-success {
        background-color: rgba(0, 128, 0, 0.15);
        color: green;
    }

    &-error {
        background-color: rgba(255, 0, 0, 0.15);
        color: red;
    }
}
</style>
